import Button from 'react-bootstrap/Button';
import OAuthService from '../../../services/OauthService';
import React from 'react';
import { useMeQuery } from '../../../generated/graphql';
import { useTranslation } from 'react-i18next';

interface LoginButtonProps {}

export const LoginButton: React.FC<LoginButtonProps> = () => {
    const { t } = useTranslation();
    const { refetch, client } = useMeQuery();

    const handleLogin = async () => {
        // Clear any existing auth state
        localStorage.removeItem('token');
        await client.resetStore();
        
        // Store the current URL to return to after login
        localStorage.setItem('returnUrl', window.location.pathname);
        OAuthService.redirectToLogin();
    };

    return (
        <Button
            onClick={handleLogin}
            style={{
                backgroundColor: '#ffffff',
                borderColor: '#2196F3',
                color: '#2196F3',
            }}
            className="fw-bold"
        >
            {t('header.login')}
        </Button>
    );
};
